import React, { useRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { ExcelExport, ExcelExportColumn, toDataURL } from "@progress/kendo-react-excel-export";
import dayjs from "../../../../../util/dayjs-config";

export const handleDealExport = async ({ summaryRef, exportRef, selectedDeal }) => {
  const timestamp = dayjs().format("YYYY-MM-DD HH-mm-ss");
  const fileName = `${selectedDeal?.ProjectName ?? "Deal"} - Time Log ${timestamp}.xlsx`;
  const summaryWb = summaryRef.current?.workbookOptions();
  if (summaryWb?.sheets?.length) summaryWb.sheets[0].title = "Summary";
  const detailWb = exportRef.current?.workbookOptions();
  if (detailWb?.sheets?.length) detailWb.sheets[0].title = "Details";
  const dataUrl = await toDataURL({
    sheets: [...(summaryWb?.sheets || []), ...(detailWb?.sheets || [])],
  });
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const DealExcelExports = ({ summaryData, filteredMembers, summaryRef, exportRef }) => (
  <>
    <ExcelExport data={summaryData} ref={summaryRef}>
      <ExcelExportColumn field="ProjectName" title="Deal Name" />
      <ExcelExportColumn field="LastWeekHours" title="Last Wk Hrs" />
      <ExcelExportColumn field="WeekendHours" title="Last Wknd Hrs" />
      <ExcelExportColumn field="TotalHours" title="Actual Total Hrs" />
      <ExcelExportColumn field="CurrentWeekHours" title="Current Wk Estimate" />
      <ExcelExportColumn field="SeniorMembersCSV" title="MDs/Directors/VPs" />
    </ExcelExport>
    <ExcelExport data={filteredMembers} ref={exportRef}>
      <ExcelExportColumn field="GroupName" title="Group" />
      <ExcelExportColumn field="Banker" title="Banker" />
      <ExcelExportColumn field="LastWeekHours" title="Last Wk Hrs" />
      <ExcelExportColumn field="WeekendHours" title="Last Wknd Hrs" />
      <ExcelExportColumn field="TotalHours" title="Total Hrs" />
      <ExcelExportColumn field="CurrentWeekHours" title="Current Wk Est" />
      <ExcelExportColumn field="LastUpdated" title="Last Updated" />
    </ExcelExport>
  </>
);

DealExcelExports.propTypes = {
  summaryData: PropTypes.array.isRequired,
  filteredMembers: PropTypes.array.isRequired,
  summaryRef: PropTypes.object.isRequired,
  exportRef: PropTypes.object.isRequired,
};

export const DealWidgetExcelExport = React.forwardRef(({ data }, ref) => {
  const internalRef = useRef(null);
  useImperativeHandle(ref, () => ({
    save: async () => {
      const timestamp = dayjs().format("YYYY-MM-DD HH-mm-ss");
      const wb = internalRef.current?.workbookOptions();
      if (!wb) return;
      const dataUrl = await toDataURL(wb);
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `Deal Time Log ${timestamp}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  }));
  return (
    <ExcelExport data={data} ref={internalRef}>
      <ExcelExportColumn field="ProjectId" title="#" />
      <ExcelExportColumn field="ProjectName" title="Deal Name" />
      <ExcelExportColumn field="LastWeekHours" title="Last Wk Hrs" />
      <ExcelExportColumn field="WeekendHours" title="Last Wknd Hrs" />
      <ExcelExportColumn field="TotalHours" title="Total Hrs" />
      <ExcelExportColumn field="CurrentWeekHours" title="Current Wk Est" />
      <ExcelExportColumn field="LastUpdated" title="Last Updated" />
    </ExcelExport>
  );
});

DealWidgetExcelExport.displayName = "DealWidgetExcelExport";
